import React from "react";
import grouppic from '../img/group-pic.jpg';
import memberpix1 from '../img/memberpix1.jpg';
import memberpix2 from '../img/memberpix2.jpg';

const About = () => {
  return (
    <>
      <section className='about-section' data-aos="fade-left">
        <p className="about-headline">
          We help businesses to<br/>
          grow within a short<br/>
          period of time. 
        </p>
        <p className="about-headline-small">
          We also design and develop web and mobile apps<br/>
          for startups, small and medium businesses
        </p>
      </section>
      <section id="about-body">
        <div className="group-image-holder" data-aos="fade-left">
          <img src={grouppic}  alt="Group selfie"/>
        </div>
        <article className="about-article-one" data-aos="fade-left">
          We exist to connect you with scalable<br/>
          innovation,  so you can get on with the<br/>
          things that matter in your business.
          <p data-aos="fade-left">
            Only state-of-the-art services to keep you ahead of the changing<br/>
            business landscape from branding, to business transformation, <br/>
            building your products (software/mobile apps), technical support,<br/>
            and training
          </p>
        </article>
        <article className="about-article-two" data-aos="fade-left">
          Twice as good focusses on<br/>
          your technology, while<br/>
          you focus on your<br/>
          business.
        </article>
        <article className="member-holder" data-aos="fade-left">

          <p className="team-members">Team Members</p>
          <p className="great-movers">The Great Movers.</p>

          <article className="member-holder1">
            <div className="member-img-holder1">
              <img src={memberpix2} alt="Member selfie"/>
            </div>
            <p className="member-name">Samuel</p>
            <p className="member-title">Chief Executive Officer</p>
          </article>

          <article className="member-holder2">
            <div className="member-img-holder2">
              <img src={memberpix1} alt="Member selfie"/>
            </div>
            <p className="member-name">Augustine</p>
            <p className="member-title">Chief Operation Officer</p>
          </article>

        </article>
      </section>
    </>
  );
};
export default About;
